export enum AnalystRatings {
  BUY = 'BUY',
  STRONG_BUY = 'STRONG_BUY',
  SELL = 'SELL',
  STRONG_SELL = 'STRONG_SELL',
  HOLD = 'HOLD',
  UNDERPERFORM = 'UNDERPERFORM'
}

export interface RatingsConsensus {
  overallConsensus: AnalystRatings;
  numberOfAnalysts: number;
  ratingBuy: number;
  ratingHold: number;
  ratingSell: number;
}

